module.exports = __webpack_public_path__ + "assets/template-category-role.e5edda60.svg";